<p-calendar *ngIf="events && !readonly" [ngClass]="selectionMode" class="custom-calendar" [formControl]="form"
    [inline]="inline" [selectionMode]="selectionMode" (onSelect)="select($event)" [disabledDates]="disabledDates"
    [dateFormat]="format" [selectOtherMonths]="true" [showIcon]="true" [showOnFocus]="false" [minDate]="minDate" [maxDate]="maxDate"
    [icon]="'icon icon-24-px-calendario'" [readonlyInput]="true" [appendTo]="appendTo || null " [yearNavigator]="yearNavigator" [monthNavigator]="monthNavigator" [yearRange]="yearRange"
    [showButtonBar]="showButtonBar" [disabled]="readonly" (onClearClick)="clearClick($event)" #calendarRef>
    <!-- Disabled does not work when using reactive forms -->
    <ng-template pTemplate="date" let-date>
        {{date.day}}
        <div class="inline-bullets">
            <div class="row">
                <div class="col-4 p-0" *ngFor="let severity of matchDate(date)">
                    <div class="bullet" [ngClass]="{'danger' : severity === 'HIGH', 'warn': severity === 'MEDIUM',
                'success': severity === 'LOW'}"></div>
                </div>
            </div>
        </div>
    </ng-template>
</p-calendar>
<div class="d-flex align-items-center input-container" #inputContainerRef *ngIf="readonly">
    <input class="read-only-input px-3 py-2" [value]="readOnlyValue" [ngClass]="{'hasAddon': buttonIcon}"
        [readonly]="true" #inputRef />
    <div class="input-addon">
        <i class="icon icon-24-px-calendario d-flex align-items-center"></i>
    </div>
</div>

<mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="calendarRef"></mapfre-auditlib-form-errors>
